import { Controller } from '@hotwired/stimulus';
import { MDCRipple } from '@material/ripple';

export default class extends Controller {
  connect() {
    this.ripple = new MDCRipple(this.element);
  }

  disconnect() {
    if (this.ripple) {
      this.ripple.destroy();
    }
  }

  // Delegate an action to another controller on the page.
  invokeOtherController({ params }) {
    const controller = this.application.getControllerForElementAndIdentifier(
      document.querySelector(params.otherElementSelector),
      params.otherControllerName
    );
    controller[params.otherControllerAction](params);
  }
}
